export const CHeaderTopBarFragments = {
  field: `
    fragment headerTopBar on headerTopBar_MatrixField {
      ... on headerTopBar_topBar_Entry {
        showSafetyInformationLink
        safetyInformationLinkText
        safetyInformationLinkUrl
      }
    }
  `,
}
